const initialState = {
   data: {
      msg_data: [],
   },
   isLoading: true,
};

export default initialState;
